export default {"src":"/_next/static/media/ye.da6d3351.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};